// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EnrollmentClientIdentifiersModel {
    'sourceId'?: string;
    'alternateId'?: string;
    'alternateIdType'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnrollmentClientIdentifiersModel>> = [
        {
            "name":     "sourceId",
            "baseName": "sourceId",
            "type":     "string"
        },
        {
            "name":     "alternateId",
            "baseName": "alternateId",
            "type":     "string"
        },
        {
            "name":     "alternateIdType",
            "baseName": "alternateIdType",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return EnrollmentClientIdentifiersModel.attributeTypeMap;
    }
}
